module.exports = __webpack_public_path__ + "static/media/4B.5e59276e.png";